module.exports = "/static/assets/2598837e0a24e0d170ed53318b9b797a.png";